/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useMemo, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

import { Icon } from 'bd-web-components'

import { GRAY_SCALE_04 } from 'bd-web-components/src/utils/dash-colors'

import {
  Container,
  ImgLogo,
  HalfHeader,
  OtherHalf,
  VerticalDivider,
  ContentContainer,
  HamburgerIcon,
  HamburgerIconContainer,
  Menu,
  MenuDesktop,
  MenuMobile,
  MenuOptionMobile,
  MenuButton,
  LinkLogo,
  MenuLink,
  FormDivider,
} from './styles'

import logo from '../../assets/logo.svg'
import logoRebrand from '../../assets/logo-rebrand.svg'

import { useUser, useLogout, useHasAccess } from '../../hooks/auth'

import MenuModal from '../MenuHamburger'
import { isNavLinkActive, isRouteActive } from '../../utils/router'
import { useHeaderLinks } from '../../hooks/navigation'
import useBdApp from '../../hooks/bdapp/useBdApp'

interface Props {
  toggleTheme?(): void
  menu?: boolean
}

const Header: React.FC<Props> = ({ toggleTheme, menu }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { dispatch } = useLogout()
  const user = useUser()
  const { isNative } = useBdApp()

  const [menuOpen, setMenuOpen] = useState(false)
  const [headerOpen, setHeaderOpen] = useState<boolean>(false)
  const [accountOpen, setAccountOpen] = useState<boolean>(false)

  const handleMenuToggle = (value: boolean) => {
    setMenuOpen(value)
    setHeaderOpen(false)
    setAccountOpen(false)
  }

  const handleHeaderToggle = (value: boolean) => {
    setHeaderOpen(value)
    setAccountOpen(false)
  }

  const handleAccountToggle = (value: boolean) => {
    setAccountOpen(value)
    setHeaderOpen(false)
  }

  const navLinks = useHeaderLinks()
  const accessAddAccount = useHasAccess('DP5')
  const getCurrentPath = (path: string) => isRouteActive(location, path)

  const currentMobileLabel = useMemo(() => {
    const active = navLinks.find(
      (link) => link.visible && isNavLinkActive(location, link)
    )
    return active?.label ?? ''
  }, [location, navLinks])

  if (isNative)
    return (
      <MenuModal
        isOpen={menuOpen}
        onRequestClose={() => handleMenuToggle(false)}
      />
    )

  return (
    <Container>
      <ContentContainer>
        <HalfHeader>
          <LinkLogo
            href="/start"
            onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
              e.preventDefault()
              navigate('/start')
            }}
          >
            <ImgLogo src={process.env.REACT_APP_REBRAND === 'true' ? logoRebrand : logo} alt="Logotipo Bilheteria digital" />
          </LinkLogo>
          <VerticalDivider />

          <MenuDesktop>
            {navLinks
              .filter((l) => l.visible)
              .map((l) => (
                <Menu
                  key={l.key}
                  className={isNavLinkActive(location, l) ? 'active' : ''}
                  onClick={() => navigate(l.to)}
                  rel="noreferrer"
                >
                  {l.label}
                </Menu>
              ))}
          </MenuDesktop>

          {menu && (
            <MenuButton
              className={menuOpen ? 'active' : ''}
              onClick={() => handleMenuToggle(!menuOpen)}
            >
              <Icon
                fill={menuOpen ? '#FFF' : '#000'}
                classes="question-circle-help-center"
                iconName="userInterfaceLayer"
                width={16}
                height={16}
              />
              {'Menu'}
            </MenuButton>
          )}

          <MenuMobile onClick={() => handleHeaderToggle(!headerOpen)}>
            <p>{currentMobileLabel}</p>
            <Icon
              fill={'#FFF'}
              classes="question-circle-help-center"
              iconName="downArrow"
              width={12}
              height={12}
            />

            {headerOpen === true && (
              <MenuOptionMobile>
                {navLinks
                  .filter((l) => l.visible)
                  .map((l) => (
                    <Menu
                      key={`mobile-${l.key}`}
                      className={
                        isNavLinkActive(location, l) ? 'active' : ''
                      }
                      onClick={() => navigate(l.to)}
                      rel="noreferrer"
                    >
                      {l.label}
                    </Menu>
                  ))}
              </MenuOptionMobile>
            )}
          </MenuMobile>
        </HalfHeader>
        <OtherHalf>
          <div
            style={{
              padding: '14px 14px 10px 14px',
              backgroundColor: '#FFF',
              borderRadius: 300,
              cursor: 'pointer',
            }}
            onClick={() => handleAccountToggle(!accountOpen)}
          >
            <Icon
              fill={'#000'}
              classes="question-circle-help-center"
              iconName="userProfile"
              width={24}
              height={24}
            />
          </div>

          {accountOpen === true && (
            <MenuOptionMobile className="right">
              <MenuLink>
                <Icon
                  fill={GRAY_SCALE_04}
                  classes="question-circle-help-center"
                  iconName="userProfile"
                  width={24}
                  height={24}
                />
                <p>{user?.usuario}</p>
              </MenuLink>
              <FormDivider />
              <MenuLink className="logout" onClick={() => dispatch()}>
                <Icon
                  fill={'red'}
                  classes="question-circle-help-center"
                  iconName="rightAlignment"
                  width={24}
                  height={24}
                />
                <p>Sair</p>
              </MenuLink>
            </MenuOptionMobile>
          )}
        </OtherHalf>
        <MenuModal
          isOpen={menuOpen}
          onRequestClose={() => handleMenuToggle(false)}
        />
      </ContentContainer>
    </Container>
  )
}

export default Header
